// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop_Backdrop__h49-+","High":"Backdrop_High__t72tj"};